import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "mb-6" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_center = _resolveComponent("center")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.todayAbsence.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_progress_linear, {
                    class: "mx-2",
                    color: "primary",
                    indeterminate: ""
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.attendance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_breadcrumbs, {
                      class: "px-0",
                      items: _ctx.breadcrumbsItems
                    }, null, 8, ["items"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h2", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('attendance.absenceConfirmDelete')), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.attendance.child.lastName) + _toDisplayString(_ctx.attendance.child.firstName), 1)
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.date')) + " : " + _toDisplayString(_ctx.formatDate(_ctx.attendance.date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('attendance.reason')), 1),
                    (_ctx.todayAbsence[0] && _ctx.todayAbsence[0].absenceDetails)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_card_text, { style: {"white-space":"pre-wrap"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.showReason(_ctx.todayAbsence[0].absenceDetails.reason)), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.todayAbsence[0].absenceDetails.comment)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_v_card_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('attendance.comment')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_card_text, { style: {"white-space":"pre-wrap"} }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.todayAbsence[0].absenceDetails.comment), 1)
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_v_row, {
                    justify: "center",
                    class: "pt-10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _ctx.deleteAbsence,
                        disabled: _ctx.isSaving,
                        color: "error",
                        variant: "outlined",
                        "x-large": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    (_ctx.isSaving)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "primary",
                          class: "my-8"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_dialog, {
              "max-width": "640px",
              modelValue: _ctx.isAbsenceRegisterDialogOpen,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isAbsenceRegisterDialogOpen) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar, {
                      dark: "",
                      color: "primary",
                      tile: "",
                      flat: "",
                      class: "mb-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('attendance.absenceRegistration', { name: _ctx.attendance.child.lastName + ' ' + _ctx.attendance.child.firstName })), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", null, [
                        _createVNode(_component_center, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.attendance.date)), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_v_card_text, { class: "py-3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.reason,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event)),
                          rules: [_ctx.rules.required],
                          label: _ctx.$t('attendance.reason'),
                          items: _ctx.choices,
                          "item-title": "text",
                          "item-value": "value",
                          variant: "outlined",
                          density: "compact",
                          color: "primary"
                        }, null, 8, ["modelValue", "rules", "label", "items"]),
                        (_ctx.reason === 'infection')
                          ? (_openBlock(), _createBlock(_component_v_select, {
                              key: 0,
                              modelValue: _ctx.infectionReason,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.infectionReason) = $event)),
                              rules: [_ctx.infectionRules],
                              label: _ctx.$t('attendance.detail'),
                              items: _ctx.infectionChoices,
                              "item-title": "text",
                              "item-value": "value",
                              variant: "outlined",
                              density: "compact",
                              color: "primary"
                            }, null, 8, ["modelValue", "rules", "label", "items"]))
                          : _createCommentVNode("", true),
                        (_ctx.reason === 'others')
                          ? (_openBlock(), _createBlock(_component_v_textarea, {
                              key: 1,
                              modelValue: _ctx.comment,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.comment) = $event)),
                              rules: [_ctx.rules.counter500],
                              label: _ctx.$t('attendance.comment'),
                              "auto-grow": "",
                              variant: "outlined",
                              density: "compact",
                              color: "primary"
                            }, null, 8, ["modelValue", "rules", "label"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: _ctx.isSaving,
                          variant: "flat",
                          color: "primary",
                          class: "mx-2",
                          onClick: _ctx.clickAbsencePost
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ]),
                      _: 1
                    }),
                    (_ctx.isUpdatingStaffs)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "primary"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_v_progress_linear, {
                    class: "mx-2",
                    color: "primary",
                    indeterminate: ""
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.attendance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_breadcrumbs, {
                      class: "px-0",
                      items: _ctx.breadcrumbsItems
                    }, null, 8, ["items"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.formatDate(_ctx.attendance.date)) + " : " + _toDisplayString(_ctx.attendance.child.lastName) + _toDisplayString(_ctx.attendance.child.firstName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('attendance.checkInTime')), 1),
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      type: "time",
                      modelValue: _ctx.attendedAt,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.attendedAt) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('attendance.checkOutTime')), 1),
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      type: "time",
                      modelValue: _ctx.leftAt,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.leftAt) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_v_row, { justify: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "flat",
                        "x-large": "",
                        disabled: _ctx.isSaving,
                        onClick: _ctx.save
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    justify: "center",
                    class: "pt-10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _ctx.deleteAttendance,
                        disabled: _ctx.isSaving || _ctx.attendance.attendanceId == -1,
                        color: "error",
                        variant: "outlined",
                        "x-large": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('attendance.deleteCheckInOut')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    justify: "center",
                    class: "pt-10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _ctx.openModalAbsence,
                        disabled: _ctx.isSaving || _ctx.attendedAt !== null,
                        color: "primary",
                        variant: "outlined",
                        "x-large": ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('attendance.registerAbsence')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    (_ctx.isSaving)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "primary",
                          class: "my-8"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}